export default __webpack_public_path__ + "static/media/war1.da7a48ca.png";